import { render, staticRenderFns } from "./EKatalog.vue?vue&type=template&id=474d56a8"
import script from "./EKatalog.vue?vue&type=script&lang=js"
export * from "./EKatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports